var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.globalLoading
    ? _c(
        "overview",
        {
          attrs: {
            name: _vm.name,
            dataoverview: _vm.dataoverview,
            mappingName: _vm.mappingName,
            overviewClass: _vm.overviewClass,
            nav: _vm.navMap,
            moreNav: _vm.moreNav,
            contextId: _vm.contextId
          }
        },
        [
          _c(
            "template",
            { slot: "header" },
            [
              _c("overview-header-opportunity", {
                attrs: {
                  overviewhash: _vm.overviewhash,
                  actions: _vm.headerActions
                }
              })
            ],
            1
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }